export const CreditNotesRouteNames = {
  create: 'credit-notes.create',
  edit: 'credit-notes.edit',
} as const

export enum CreditNoteStatus {
  Draft = 'Draft',
  Approved = 'Approved',
  Sent = 'Sent',
  Cancelled = 'Cancelled',
}
